import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "modal-dialog"
}
const _hoisted_4 = {
  key: 1,
  class: "modal-dialog modal-lg modal-dialog-scrollable"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "alert alert-danger text-dark" }
const _hoisted_8 = {
  key: 0,
  class: "card"
}
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "list-group list-group-flush" }
const _hoisted_11 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_12 = {
  key: 1,
  class: "card mt-2"
}
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "list-group list-group-flush" }
const _hoisted_15 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_16 = {
  key: 2,
  class: "card mt-2"
}
const _hoisted_17 = { class: "card-header" }
const _hoisted_18 = { class: "list-group list-group-flush" }
const _hoisted_19 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_20 = {
  key: 2,
  class: "modal-dialog"
}
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = { class: "modal-body" }

import { computed, toRef } from 'vue'
    import { useRoute } from 'vue-router'

    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'

    import type { ProjectUserDeleterViewModel } from '@ProjectUsers/Components/ProjectUserDeleter'
    import type { DependentEntityInfo } from '@common/types'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectUserDeleter',
  props: {
    viewModel: {}
  },
  emits: ["delete-project-user", "archive-project-user"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- router ----------------

    const route = useRoute()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const projectUserId = computed(() => vm.value.projectUserId)
    const projectUserName = computed(() => vm.value.projectUserName)

    const initialized = computed(() => vm.value.deps != null)

    const hasDependants = computed(() => vm.value.deps?.HasDependants ?? false)
    const dependenciesCount = computed(() => vm.value.deps?.DependenciesCount ?? 0)

    const estimationsSurveys = computed(() => vm.value.deps?.EstimationsSurveys ?? [])
    const criteriaSurveys = computed(() => vm.value.deps?.CriteriaSurveys ?? [])
    const scoringSurveys = computed(() => vm.value.deps?.ScoringSurveys ?? [])

    // ---------------- url helpers ----------------

    function url_CriteriaPanelistsPage(s: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Evaluation_CriteriaPanelistsPage(
            route,
            s.WorkspaceId,
            s.TchProjectId,
            s.EvalModelId,
            Number.parseInt(s.Id)
        )
    }

    function url_ScoringPanelistsPage(s: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Evaluation_ScoringPanelistsPage(
            route,
            s.WorkspaceId,
            s.TchProjectId,
            s.EvalModelId,
            Number.parseInt(s.Id)
        )
    }

    function url_AssessmentsPanelistsPage(s: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Evaluation_AssessmentsPanelistsPage(
            route,
            s.WorkspaceId,
            s.TchProjectId,
            Number.parseInt(s.Id)
        )
    }

    // ---------------- actions ----------------

    function deleteProjectUser()
    {
        emit('delete-project-user', projectUserId.value)
    }

    function archiveProjectUser()
    {
        emit('archive-project-user', projectUserId.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createCommentVNode(" loading "),
          (!initialized.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", { class: "modal-content" }, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Delete user", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body" }, [
                    _createElementVNode("h4", null, [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
                      _createTextVNode(" Checking dependencies...")
                    ])
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: close,
                      class: "btn btn-outline-secondary"
                    }, "Cancel")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" has dependants "),
          (initialized.value && hasDependants.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Delete user", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "alert-heading" }, "Cannot delete this user", -1 /* CACHED */)),
                      _createElementVNode("p", null, [
                        _cache[3] || (_cache[3] = _createTextVNode(" The user '", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(projectUserName.value), 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createTextVNode("' is in ", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(dependenciesCount.value), 1 /* TEXT */),
                        _cache[5] || (_cache[5] = _createTextVNode(" places. To delete them & their votes, first remove them from the following panels. Alternatively, archive the user to keep their votes. ", -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      (criteriaSurveys.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, " Criteria panels (" + _toDisplayString(criteriaSurveys.value.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_10, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteriaSurveys.value, (s) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: s.Id
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [
                                    _createTextVNode(_toDisplayString(s.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_CriteriaPanelistsPage(s)]
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (estimationsSurveys.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, " Assessments panels (" + _toDisplayString(estimationsSurveys.value.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(estimationsSurveys.value, (s) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: s.Id
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, [
                                    _createTextVNode(_toDisplayString(s.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_AssessmentsPanelistsPage(s)]
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (scoringSurveys.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, " Scoring panels (" + _toDisplayString(scoringSurveys.value.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scoringSurveys.value, (s) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: s.Id
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, [
                                    _createTextVNode(_toDisplayString(s.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_ScoringPanelistsPage(s)]
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: archiveProjectUser,
                      class: "btn btn-primary"
                    }, "Archive"),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: close,
                      class: "btn btn-outline-secondary"
                    }, "Cancel")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" no dependants "),
          (initialized.value && !hasDependants.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", { class: "modal-header bg-danger text-white" }, [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "modal-title" }, "Delete user", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close text-white",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[10] || (_cache[10] = _createElementVNode("h4", null, "Are you sure you want to delete this user?", -1 /* CACHED */)),
                    _createElementVNode("p", null, [
                      _cache[8] || (_cache[8] = _createTextVNode(" You are about to delete '", -1 /* CACHED */)),
                      _createElementVNode("strong", null, _toDisplayString(projectUserName.value), 1 /* TEXT */),
                      _cache[9] || (_cache[9] = _createTextVNode("'. This can't be undone. ", -1 /* CACHED */))
                    ])
                  ]),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: deleteProjectUser,
                      class: "btn btn-danger"
                    }, "Delete"),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: close,
                      class: "btn btn-outline-secondary"
                    }, "Cancel")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})